import {
  faDownload,
  faEye,
  faTrash,
  faUserPen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "components";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import ApplicationForm from "pages/billings_plans/components/applicationForm";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "services/api";
import { RELATIONS } from "services/api.config";
import { useAuth } from "hooks";
import { toast } from "react-toastify";
import { deleteTransaction } from "services/api.config";

import MembershipCard from "pages/checkMembership/membershipCard";
import DeleteComponent from "components/deleteComponent";
import ReceiptDownloadButton from "components/ReceiptDownloadButton";
import { canDownloadReceipt } from "services/receiptService";

// Custom styles for table horizontal scrolling and sticky actions
const tableStyles = {
  tableContainer: {
    overflowX: "auto",
    position: "relative",
    maxHeight: "80vh",
    minHeight: "60vh",
    overflow: "auto",
  },
  table: {
    minWidth: "1000px",
    tableLayout: "fixed",
    whiteSpace: "nowrap",
  },
  stickyActions: {
    position: "sticky",
    right: "0",
    backgroundColor: "white",
    zIndex: "1",
    boxShadow: "-2px 0 5px rgba(0,0,0,0.1)",
    height: "45px",
  },
  tableCell: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};

export const EnrolledPlans = () => {
  const navigate = useNavigate();
  const [enrolledPlans, setEnrolledPlans] = useState([]);
  const [memberships, setMemberships] = useState([]);
  // after View click
  const [relations, setRelations] = useState([]);
  const [countries, setContries] = useState([]);
  const { user } = useAuth();
  // const params = useParams();
  const [selectPlan, setSelectPlan] = useState("");
  const [downloadMem, setDownloadMem] = useState(null);
  const tableRef = useRef(null); // Create a ref for the table
  const [deleteModel, SetDeleteModel] = useState(false);
  const [deletePayment, setDeletePayment] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" }); // Scroll to the element
  };
  const [initialValues] = useState([
    {
      membership_id: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      phone_no: "",
      email: "",
      // img: "",
      // imgpath: "",
      dob: "",
      sex: "",
      relation: "",
      // country_id: "94",
      nationality: "95",
    },
  ]);
  const validationSchema = Yup.object().shape({
    members: Yup.array().of(
      Yup.object().shape({
        first_name: Yup.string()
          .required("Required")
          .min(3, "First name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        middle_name: Yup.string()
          // .required("Required")
          // .min(3, "Middle name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        last_name: Yup.string()
          // .required("Required")
          // .min(3, "Last name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        phone_no: Yup.string()
          .required("Required")
          .length(10, "Phone number must be exactly 10 digits")
          .matches(/[0-9]+$/, "only numeric"),
        email: Yup.string().email("Invalid email").required("Required"),
        // img: Yup.string(),
        dob: Yup.string().required("Required"),
        sex: Yup.string().required("Required"),
        relation: Yup.string().required("Required"),
        // nationality: Yup.string().required("Required"),
        nationality: Yup.number().required("Required"),
      })
    ),
    agree: Yup.boolean()
      .oneOf([true], "You must accept the terms and conditions")
      .required("You must accept the terms and conditions"),
  });
  const membershipData = {
    membership_id: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    phone_no: "",
    email: "",
    // img: "",
    // imgpath: "",
    dob: "",
    sex: "",
    relation: "",
    // country_id:  "94"||"", // Initialize country as null or any default value
    nationality: "95" || "",
  };
  const fetchEnrolledPlans = async (page = 1) => {
    try {
      const response = await api.get(
        `/enrolled-plans?per_page=100&order_by=created_at&sort_order=desc`
      );
      const enrolledList = response?.data?.data;
      setEnrolledPlans(enrolledList);
    } catch (error) {
      console.log("fetchEnrolledPlans Error:", error);
    }
  };
  const renewalEnrolledPlans = async (enroll_id) => {
    try {
      // Post to the renewal plan API
      const response = await api.post("/renewal-plan", {
        enroll_id: enroll_id,
      });

      const paymentData = response?.data?.paymentData;

      if (paymentData) {
        // Create a form for payment
        const form = document.createElement("form");
        form.method = "POST";
        form.action = paymentData.action; // Payment gateway URL

        // Add payment data to the form
        Object.keys(paymentData).forEach((key) => {
          if (key !== "action") {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = paymentData[key];
            form.appendChild(input);
          }
        });

        // Append form to the document and submit
        document.body.appendChild(form);
        form.submit();
      }
    } catch (error) {
      console.log("fetchEnrolledPlans Error:", error);
      // Handle error if needed
    }
  };

  useEffect(() => {
    fetchEnrolledPlans(1);
    countriesFetch();
    fetchRelation();
  }, []);

  const fetchMembershipData = async (enrollId) => {
    try {
      const response = await api.get(
        `/membership-application?enrollId=${enrollId}`
      );
      setMemberships(response?.data.data.memberApplication);
      scrollToSection(tableRef);
    } catch (error) {
      console.log("membershipList error:", error);
    }
  };
  const fetchRelation = async () => {
    try {
      const response = await api.get(`${RELATIONS}`);
      const relationList = response?.data?.data?.relations;
      setRelations(relationList);
      // console.log("relation fetch:", relationList);
    } catch (error) { }
  };
  const countriesFetch = async () => {
    try {
      const response = await api.get("/countries");
      const countriesList = response?.data?.data?.countries;
      setContries(countriesList);
    } catch (error) {
      console.log("countriesFetch:", error);
    }
  };
  const addMemBeship = (values, setValues) => {
    const updateValues = {
      members: [...values.members, { ...membershipData, relation: "" }], //this is no auto fill relation second add member
    };
    setValues(updateValues);
    // setErrors("");
  };
  const removeMemForm = (values, setValues, index, setErrors) => {
    if (typeof setValues !== "function") {
      return;
    }

    const updatedMembers = values?.members?.filter((_, i) => i !== index);

    setValues({ ...values, members: updatedMembers });

    if (setErrors) {
      setErrors("");
    }
  };

  const openDeleteModal = (applicationId) => {
    setSelectedUserId(applicationId);
    SetDeleteModel(true);
  };

  const deleteMember = async (applicationId) => {
    if (selectedUserId) {
      try {
        await api.delete(
          `/membership-application/${selectedUserId}`
        );
        setSelectPlan("");
        fetchMembershipData();
        fetchEnrolledPlans();

        SetDeleteModel(false);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const handleSubmitEnrolledUser = async (values) => {
    let payload = [];
    values.members.forEach((mem) => {
      let obj = { ...mem };
      // delete obj.imgpath;
      obj.dob = moment(obj.dob, "DD-MM-YYYY", true).format("DD-MM-YYYY");
      payload.push(obj);
    });
    const formData = new FormData();
    payload.forEach((res, i) => {
      Object.entries(res).forEach((mem) => {
        formData.append(`${mem[0]}[${i}]`, mem[1]);
      });
    });
    formData.append("membership_id", selectPlan?.membership_id);
    // console.log("store state:", store);
    formData.append("user_id", user?.user_id);
    formData.append("enroll_id", selectPlan?.enroll_id);

    try {
      const response = await api.post("/enrolled-plan", formData);
      toast.success(response?.data?.message || "Added Succefully");
      fetchEnrolledPlans();
      fetchMembershipData();
      setSelectPlan("");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const handlePayment = async (transactionId) => {
    try {
      api
        .post(`/retry-payment`, {
          transaction_id: transactionId,
        })
        .then((res) => {
          const paymentData = res.data.data.paymentData;
          const form = document.createElement("form");
          form.method = "POST";
          form.action = paymentData.action;

          Object.keys(paymentData).forEach((key) => {
            if (key !== "action") {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = paymentData[key];
              form.appendChild(input);
            }
          });

          document.body.appendChild(form);
          form.submit();
        });
    } catch (error) {
      toast.error("Payment failed");
    }
  };

  const handleDelete = (transaction_id) => {
    setDeletePayment(true);
    setSelectedTransactionId(transaction_id);
  };

  const handleDeleteTransaction = async () => {
    if (selectedTransactionId) {
      try {
        await api.delete(
          `${deleteTransaction}?transaction_id=${selectedTransactionId}`
        );
        fetchEnrolledPlans();
        setSelectedTransactionId(null);
        setDeletePayment(false);
      } catch (error) {
        console.log("errror", error);
      }
    }
  };

  return (
    <Container>
      <div class="content-wrapper ">
        <div class="container-xxl flex-grow-1 container-p-y">
          <div
            class="card-datatable table-responsive"
            style={tableStyles.tableContainer}
          >
            <table
              class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5"
              style={tableStyles.table}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      width: "20%",
                      minWidth: "150px",
                      ...tableStyles.tableCell,
                    }}
                  >
                    Plan Name
                  </th>
                  <th
                    style={{
                      width: "12%",
                      minWidth: "100px",
                      ...tableStyles.tableCell,
                    }}
                  >
                    Plan Type
                  </th>
                  <th
                    style={{
                      width: "12%",
                      minWidth: "100px",
                      ...tableStyles.tableCell,
                    }}
                  >
                    Price
                  </th>
                  <th
                    style={{
                      width: "12%",
                      minWidth: "100px",
                      ...tableStyles.tableCell,
                    }}
                    class="text-truncate"
                  >
                    Duration
                  </th>
                  <th
                    style={{
                      width: "12%",
                      minWidth: "120px",
                      ...tableStyles.tableCell,
                    }}
                  >
                    Start Date
                  </th>
                  <th
                    style={{
                      width: "12%",
                      minWidth: "100px",
                      ...tableStyles.tableCell,
                    }}
                    class="text-truncate"
                  >
                    Status
                  </th>
                  <th
                    style={{
                      width: "15%",
                      minWidth: "150px",
                      ...tableStyles.tableCell,
                    }}
                  >
                    Available / Limit
                  </th>
                  <th
                    style={{
                      width: "17%",
                      minWidth: "150px",
                      ...tableStyles.stickyActions,
                    }}
                    class="cell-fit text-center"
                  >
                    Actions
                  </th>
                  {/* <th class="cell-fit">Add Member</th> */}
                </tr>
              </thead>
              <tbody>
                {enrolledPlans?.memberApplication?.map((res, index) => {
                  return (
                    <tr key={index}>
                      <td style={tableStyles.tableCell}>
                        {res?.membership_plan?.title}
                      </td>
                      <td style={tableStyles.tableCell}>
                        {res?.membership_plan?.membership_type}
                      </td>
                      <td style={tableStyles.tableCell}>
                        ₹ {res?.membership_plan?.package_price}
                      </td>
                      <td style={tableStyles.tableCell}>
                        {res?.membership_plan?.duration}{" "}
                        {res?.membership_plan?.duration_type}
                      </td>
                      <td style={tableStyles.tableCell}>
                        {["In-Progress", "Approved", "Rejected", "Expired"].includes(res?.status)
                          ? moment(res?.created_at).format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td style={tableStyles.tableCell}>
                        <span
                          className={`badge ${res?.status === "Pending"
                            ? "bg-warning"
                            : res?.status === "In-Progress"
                              ? "bg-info"
                              : res?.status === "Approved"
                                ? "bg-success"
                                : res?.status === "Rejected" ||
                                  res?.status === "Expired" ||
                                  res?.status === "Not-Submitted"
                                  ? "bg-danger"
                                  : ""
                            }`}
                        >
                          {res?.status}
                        </span>
                      </td>
                      <td style={tableStyles.tableCell}>
                        {res?.available_slots}/{res?.no_of_slots}
                      </td>

                      <td className="d-flex" style={tableStyles.stickyActions}>
                        {/* Show Close button only for Expired and Approved status */}
                        {(res?.status === "Approved" ||
                          res?.status === "In-Progress") && (
                            <button
                              variant="outlined"
                              className={`btn me-0 ${res?.enroll_id === selectPlan?.enroll_id
                                ? "btn-danger"
                                : "btn-primary"
                                } me-2`}
                              onClick={() => {
                                if (selectPlan) {
                                  setMemberships([]);
                                  setSelectPlan("");
                                } else if (res?.enroll_id) {
                                  setSelectPlan(res);
                                  fetchMembershipData(res?.enroll_id);
                                }
                              }}
                            >
                              {res?.enroll_id === selectPlan?.enroll_id
                                ? "Close"
                                : "View"}
                            </button>
                          )}

                        {/* Show Pay button for Pending status */}
                        {res?.status === "Pending" && (
                          <>
                            <button
                              className="btn btn-success me-2"
                              onClick={() => {
                                handlePayment(res?.tran_id);
                              }}
                            >
                              Pay
                            </button>
                            <button
                              className="btn btn-danger me-2"
                              onClick={() => {
                                handleDelete(res?.tran_id);
                              }}
                            >
                              Delete
                            </button>
                          </>
                        )}

                        {/* Receipt — approved enrollments with successful payment */}
                        {canDownloadReceipt(res) && (
                          <ReceiptDownloadButton enrollId={res?.enroll_id} />
                        )}

                        {/* Show Renewal button for Expired status */}
                        {res?.status === "Expired" && (
                          <button
                            className="btn btn-warning me-1"
                            onClick={() => {
                              // Store renewal state in sessionStorage
                              sessionStorage.setItem("isRenewal", "true");

                              renewalEnrolledPlans(res?.enroll_id);
                            }}
                          >
                            Renew
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div>
            {memberships.length > 0 && (
              <div id="membership-table" className="mt-3">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li
                      class="breadcrumb-item active font-bold"
                      style={{ fontWeight: "bold" }}
                    >
                      Plan: {memberships[0]?.membership_plan?.title}
                    </li>
                  </ol>
                </nav>
                <div class="card-datatable table-responsive">
                  <table class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
                    <thead>
                      <tr>
                        <th>FirstName</th>
                        <th>LastName</th>
                       <th class="text-truncate">Relation</th>
                        <th class="text-truncate">Status</th>
                        <th>PLAN NAME</th>
                        <th>APPLICATION NUMBER</th>
                        <th class="text-truncate">Valid Till</th>
                        <th class="text-truncate">Actions</th>
                        <th class="cell-fit">Download Card</th>
                      </tr>
                    </thead>
                    <tbody>
                      {memberships.map((res, index) => {
                        return (
                          <tr key={index}>
                            <td>{res.first_name}</td>
                            <td>{res.last_name}</td>
                            <td>{res.relation}</td>
                            <td>
                              <span
                                className={`badge ${res.status === "Pending"
                                  ? "bg-warning"
                                  : res.status === "Approved"
                                    ? "bg-success"
                                    : "bg-danger"
                                  }`}
                              >
                                {res.status}
                              </span>
                            </td>
                            <td
                              dangerouslySetInnerHTML={{
                                __html: res.membership_plan.title,
                              }}
                            />
                            <td>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  color: "inherit"
                                }}
                                onClick={() =>
                                  navigate(
                                    `/membershipDetails/${res.application_no}`
                                  )
                                }
                              >
                                {res.application_no}
                              </span>
                            </td>
                            <td style={{ minWidth: "100px" }}>
                              {res.end_date
                                ? moment(res.end_date).format("DD-MM-YYYY")
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-link btn-sm shadow-none px-0 mx-0"
                                onClick={() =>
                                  navigate(
                                    `/membershipDetails/${res.application_no}`
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faEye}
                                  size="lg"
                                  style={{ cursor: "pointer" }}
                                />
                              </button>
                            </td>
                            <td className=" text-center">
                              {res?.status === "Approved" &&
                                res?.kyc_details?.status === "Approved" ? (
                                <button
                                  variant="outlined"
                                  className="btn btn-primary mx-2"
                                  onClick={() => setDownloadMem(res)}
                                >
                                  <FontAwesomeIcon
                                    icon={faDownload}
                                    size="xs"
                                  />
                                </button>
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {downloadMem && (
                  <MembershipCard
                    membershipDetails={downloadMem}
                    setDownloadMem={setDownloadMem}
                  />
                )}
              </div>
            )}
            <div ref={tableRef}></div>
            {selectPlan?.enrollUser?.status !== "Expired" &&
              (Number(selectPlan?.enrollUser?.available_slots ?? selectPlan?.available_slots ?? 0) > 0) && (
                // memberships[0]?.enrollUser?.available_slots > 0 &&
                <Formik
                  initialValues={{ members: initialValues }}
                  validationSchema={validationSchema}
                  // enableReinitialize
                  onSubmit={(values) => {
                    handleSubmitEnrolledUser(values);
                  }}
                >
                  {({
                    values,
                    setFieldValue,
                    errors,
                    setValues,
                    setFieldError,
                    setErrors,
                    validateForm,
                    touched,
                    submitCount,
                  }) => (
                    <>
                      <Form>
                        {values?.members?.map((mem, i) => {
                          const availableSlotsFromApi = Number(
                            memberships?.[0]?.enrollUser?.available_slots ??
                              selectPlan?.enrollUser?.available_slots ??
                              selectPlan?.available_slots ??
                              0
                          );
                          return (
                            <ApplicationForm
                              key={i}
                              setFieldValue={setFieldValue}
                              relations={relations}
                              countries={countries}
                              values={values}
                              addMemBeship={() =>
                                addMemBeship(values, setValues)
                              }
                              setValues={setValues}
                              mem={mem}
                              activeMembership={{
                                ...selectPlan,
                                no_of_users: selectPlan?.no_of_slots,
                              }}
                              isLast={values?.members?.length - 1 === i}
                              validateForm={validateForm}
                              setErrors={setErrors}
                              removeMemForm={() =>
                                removeMemForm(values, setValues, i, setErrors)
                              }
                              formIndex={i}
                              isDynamic={true}
                              availableSlots={availableSlotsFromApi}
                            />
                          );
                        })}
                        <div class="card mb-4  mx-4">
                          <h5 class="card-header">Consent</h5>
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-12 mb-1">
                                <div class="mb-3">
                                  <p>
                                    <Field
                                      class="form-check-input me-2"
                                      type="checkbox"
                                      name="agree"
                                    />{" "}
                                    I agree to &nbsp;
                                    <Link to="/termsConditions" target="blank">
                                      Terms and Conditions
                                    </Link>{" "}
                                    and{" "}
                                    <Link to="/privacyPolicy" target="blank">
                                      Privacy Policy
                                    </Link>{" "}
                                    <br />
                                  </p>
                                  {errors.agree &&
                                    (touched.agree || submitCount > 0) && (
                                      <div className="invalid-form">
                                        {errors.agree}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div class="mt-2">
                              <button
                                // type={values?.agree ? "submit" : "button"}
                                class="btn btn-primary me-2"
                                type="submit"
                              // onClick={() =>
                              //   values?.agree != true &&
                              //   setFieldError(
                              //     "agree",
                              //     "You must accept the terms and conditions"
                              //   )
                              // }
                              >
                                Add
                              </button>
                              <button
                                type="reset"
                                class="btn btn-label-secondary"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  )}
                </Formik>
                // <h1>hi</h1>
              )}
          </div>
          {deleteModel && (
            <DeleteComponent
              show={deleteModel}
              onClose={() => SetDeleteModel(false)}
              onDelete={deleteMember}
              message="Are you sure you want to delete this membership?"
            />
          )}

          {deletePayment && (
            <DeleteComponent
              show={deletePayment}
              onClose={() => setDeletePayment(false)}
              onDelete={handleDeleteTransaction}
              message="Are you sure you want to delete this payment?"
            />
          )}
        </div>
      </div>
    </Container>
  );
};
